import { addSeconds } from 'date-fns';
import { Middleware } from 'redux';

import {
  getDataFromStorage,
  setDataToStorage,
  TIMERS_DELAY,
} from 'hooks/usePromoteVipPopup';
import { authSuccess } from 'store/auth/authSlice';

export const refreshPromoteVipPopupMiddleware: Middleware =
  () => (next) => (action) => {
    if (action.type === authSuccess.type) {
      const storageData = getDataFromStorage();

      if (storageData) {
        setDataToStorage(
          TIMERS_DELAY.map((delay) => {
            return {
              id: delay,
              isActivated: false,
              delay: String(addSeconds(new Date(), delay)),
            };
          })
        );
      }
    }

    return next(action);
  };
